export default "__VITE_ASSET__81378319__"